'use client';
import { useStableCallback } from '@base-ui/utils/useStableCallback';

export function useFieldResetValue<Value>(
  controlled: boolean,
  value: Value,
  setValue: (value: Value) => void,
  coerceValue?: (initialValue: unknown) => Value,
) {
  return useStableCallback((initialValue: unknown) => {
    if (controlled) {
      return value;
    }

    const nextValue = coerceValue ? coerceValue(initialValue) : (initialValue as Value);
    setValue(nextValue);
    return nextValue;
  });
}
